// src/hooks/termOfPayments/useGetTermOfPaymentsForSelect.js
import { useQuery } from "@tanstack/react-query";
import { getTermOfPaymentsForSelect } from "../../api/apiTermOfPayments";
import i18next from "i18next";

const useGetTermOfPaymentsForSelect = () => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["termOfPaymentsForSelect", i18next.language],
        queryFn: getTermOfPaymentsForSelect,
    });

    const forSelect = data?.data || [];

    return { forSelect, isLoading, error, refetch };
};

export default useGetTermOfPaymentsForSelect;